import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Global from '../../../../../store/global-selectors';
import { isShipFromExternal } from '../../../../../store/csw/csw.fulfillment-plan-to-csw';
import { useShipFromValidation } from '../../../../../ship-from/components/ship-from-dropdown/validator';
import { emptyObject } from 'ui-components/default-props/empty';

const shipFromsAndActiveFulfillmentProvidersSelector = createSelector(
  Global.selectSellerShipFroms,
  Global.selectSellerActiveFulfillmentProviders,
  (sellerShipFroms, sellerFulfillmentProviders) => sellerFulfillmentProviders.concat(sellerShipFroms),
);

// NOTE: This could be refactored into a hook if we wanted since it returns an object containing validation results
export const ShipFromValidatorWithDefault = ({ selectedShipFromId, children }) => {
  const shipFroms = useSelector(shipFromsAndActiveFulfillmentProvidersSelector);
  const isExternalShipFrom = selectedShipFromId && isShipFromExternal(selectedShipFromId);

  const validationResults = useShipFromValidation({
    selectedShipFromId,
    shipFroms,
    carrierId: '',
    showError: false,
  });

  if (!selectedShipFromId) {
    return children(emptyObject);
  }

  return children({
    ...(!isExternalShipFrom && validationResults),
  });
};

ShipFromValidatorWithDefault.propTypes = {
  children: PropTypes.func.isRequired,
  selectedShipFromId: PropTypes.string,
};
